import PageHero from '../components/sections/PageHero';
import IndustriesGrid from '../components/sections/IndustriesGrid';
import CtaBanner from '../components/sections/CtaBanner';

export default function Industries() {
  return (
    <>
      <PageHero
        eyebrow="Industries we serve"
        title="Ten sectors, ten different definitions of a safe disposal"
        description="We adapt packaging, crew clearance, destruction protocol and documentation to the regulatory reality of your industry — not the other way round."
      />

      <IndustriesGrid />
      <CtaBanner />
    </>
  );
}
